import { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "../api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const u = await adminApi.me();
        setUser(u);
      } catch (e) { /* not logged in */ }
      finally { setLoading(false); }
    })();
  }, []);

  const login = async (email, password) => {
    const u = await adminApi.login(email, password);
    setUser(u);
    return u;
  };

  const logout = async () => {
    try { await adminApi.logout(); } catch (e) { console.error("logout", e); }
    setUser(null);
  };

  return (
    <AdminAuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
